<template>
    <a-spin :spinning="loading">
    <div class="m-t-25 s_bor_cbed s_bor10 s_over_h s_borList" v-if='list.length > 0'>
       <div class="s_flex" style="background:#83c8dd;line-height:50px;padding-left:30px;color:#fff;fontsize:15px">
        <div style="width:20%">视频封面</div>
        <div style="width:34%">链接</div>
        <div style="width:33%">同步时间</div>
        <div style="width:13%">操作</div>
      </div>
      <div class="p-t-15 p-b-15 p-l-20 p-r-20 s_flex_bian_c s_bb1 s_borListItem" v-for='item in list' :key='item.id'>
        <div class="width50 s_flex_ali">
          <img class="width-100 height-100 m-r-20" :src="item.cover_image?oss+item.cover_image:defaultImg" alt="">
          <p class="s_c333 s_omit width100">{{item.wx_file_url || '无'}}</p>
        </div>
        <p class="s_c999 flex_1 m-l-40">{{item.create_time}}</p>
        <div class="width15 s_flex_bian_c">
          <!-- <a class="flex_1" style="text-align:center" href="javascript:;" @click="edit(item)">编辑</a> -->
          <a class="flex_1" style="text-align:center" href="javascript:;" v-has:wxVideoDel="()=>del(item)">删除</a>
          <a class="flex_1" style="text-align:center" href="javascript:;" v-has:wxVideoLook="()=>open(item)">查看视频</a>
        </div>
      </div>
    </div>
    <div v-if="list.length==0" class='p-50'>
      <a-empty :description="false" />
    </div>
  </a-spin>
   <a-pagination :style="{marginTop:'25px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `"  />

</template>

<script>
import {wxMaterialVideo,delWxMaterialVideo} from '@/api/public_wx'
import { message } from "ant-design-vue";
import { iscode } from "@/utils/app";
import { reactive,toRefs,ref, onMounted,inject } from 'vue'
import config from "@/config";
let defSearch = {
  page: 1,
  limit: 10,
  keyword: "",
};

export default{
    setup(){
        const $Modal = inject("$Modal");
      const search = ref({ ...defSearch });
      const state = reactive({
           loading:false,
           defaultImg:require('@/assets/images/video.png'),
           list:[{id:1},{id:2}],
           total: 1,
           visible:false,
           audioData:{name:''}
      })

      const methods = {
         async initData(values){
             state.loading = true;
             let res = await wxMaterialVideo(values).then((res) => res.data);
             state.loading = false;
             if (iscode(res)) {
               state.list = res.data.data;
               state.total = res.data.total;
             }
         },
         edit(item){
             state.audioData = JSON.parse(JSON.stringify(item)) || {}
             state.visible = true;
         },
         del(item){
           $Modal.confirm({
                  centered: true,
                  content: "删除后该视频将无法恢复，您确定要删除该视频吗？",
                  onOk: async () => {
                    let res = await delWxMaterialVideo({ id: item.id }).then((res) => res.data);
                    if (iscode(res, true)) {
                      methods.initData(search.value);
                    }
                  },
                });
         },
         open(item){
             window.open(item.wx_file_url)
         },
         // 分页当前页切换
        pageCurrentChange(page, pageSize){
           search.value.page = page;
           methods.initData(search.value);
         },
         // 分页当前页显示多少条切换
         pageSizeChange(current, limit){
           search.value.page = 1;
           search.value.limit = limit;
           methods.initData(search.value);
         },
      }
      onMounted(()=>{
           methods.initData(search.value)
      })
      return{
          ...toRefs(state),
          ...methods,
          search,
          oss:config.oss[process.env.VUE_APP_type]
      }
    }
}
</script>
